import { addDoc, collection, getFirestore } from 'firebase/firestore';
import { createUserWithEmailAndPassword, getAuth } from 'firebase/auth';
import { getStorage, ref, uploadBytes } from 'firebase/storage';
import React, { useState } from 'react';
import { app } from '../../util/firebase';

const AddClient = () => {
    
    const [name,setName] = useState("")
    const [adresse,setAdresse] = useState("")
    const [number,setNumber] = useState("")
    const [email,setEmail] = useState("")
    const [password,setPassword] = useState("")
    const [img,setImg] = useState(null)

    let randomNumber = Math.round(Math.random() * 10000)

    const submit =(e)=>{
        e.preventDefault()

        let hospital = {
            userName:name,
            adresse:adresse,
            phoneNumber:number,
            email:email,
            password:password,
            status:'client',
            isArchived:false,
            imgSrc:'https://firebasestorage.googleapis.com/v0/b/e-sante-dfb1e.appspot.com/o/client%2Fprofiles%2F'+randomNumber+img.name+'?alt=media'
        }

        createUserWithEmailAndPassword(getAuth(app),email,password)
        .then(result=>{
            const storageRef = ref(getStorage(app),'client/profiles/'+randomNumber+img.name)
            uploadBytes(storageRef,img)
            .then(result=>{
                addDoc(collection(getFirestore(app),"users"),hospital)
                .then(result=>{
                    alert("Vous avez ajouté un nouveau client")
                })
                .catch(err=>alert(err))
            })
            .catch(err=>alert(err))
        })
        .catch(err=>alert(err))
    }

    return (
        <div>
            <div>
                <div className='col-12 col-md-6 m-auto shadow p-3 my-3 my-md-5 '>
                    <h2 className='text-center'>Ajouter un nouveau client</h2>
                    <form onSubmit={e=>submit(e)}>
                        <input required className='form-control my-3' type="text" placeholder='Nom du client' value={name} onChange={e=>setName(e.target.value)}></input>
                        <input required className='form-control my-3' type="text" placeholder='Addresse' value={adresse} onChange={e=>setAdresse(e.target.value)}></input>
                        <input required className='form-control my-3' type="number" placeholder='Numéro de téléphone' value={number} onChange={e=>setNumber(e.target.value)}></input>
                        <input required className='form-control my-3' type="email" placeholder='Email' value={email} onChange={e=>setEmail(e.target.value)}></input>
                        <input required className='form-control my-3' type="password" placeholder='Mot de passe' value={password} onChange={e=>setPassword(e.target.value)}></input>
                        <input required className='form-control my-3' type="file" onChange={e=>setImg(e.target.files[0])}></input>
                        <button className='btn btn-primary col-12'>Inscrire un nouveau client</button>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default AddClient;